<template>
  <v-footer class="footer">
    <v-row class="container-fluid naj-footer-margin">
      <v-col
        cols="6"
        class="text-right"
      >
        {{ local.footer.rights }} &copy; {{ currentYear }}
      </v-col>
      <v-col
        cols="6"
        class=""
      >
        <div class="text-md-end footer-links  naj-footer-align">
          <router-link to="'/'">
            عن المجلس
          </router-link>
          <a href="https://www.scj.gov.sa/#contact">
            المساعدة
          </a>
          <router-link to="'/'">
            تواصل معنا
          </router-link>
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

export default {
  name: 'NajFooter',
  components: {},
  data() {
    return {
      currentYear: (new Date()
        .getFullYear()),
    };
  },
  computed: {},
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
  bottom: 0 !important;
  left: 0 !important;
  color: #6c757d !important;
  background-color: #e3e9ed !important;
}
.footer .footer-links a {
  color: #6c757d;
  margin-right: 1.5rem;
  transition: all 0.4s;
}
::v-deep .naj-footer-align {
  display: flex !important;
  justify-content: flex-end !important;
}
.naj-footer-margin {
  margin: auto;
}
</style>
